import { styled, SxProps, Theme } from '@mui/material';
import React from 'react';

const Base = styled('div', {
    shouldForwardProp: prop => prop !== 'position' && prop !== 'sx',
})<{
    position: AdornmentPosition;
}>(({ position }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexShrink: 0,
    position: 'absolute',
    userSelect: 'none',
    right: position === 'end' ? 12 : 'auto',
    left: position === 'start' ? 12 : 'auto',
}));

export type AdornmentPosition = 'start' | 'end';

export interface AdornmentProps {
    children: React.ReactNode;
    position: AdornmentPosition;
    sx?: SxProps<Theme>;
}

const Adornment = React.forwardRef<HTMLDivElement, AdornmentProps>(
    ({ children, position, sx }, ref) => {
        return (
            <Base ref={ref} position={position} sx={sx}>
                {children}
            </Base>
        );
    }
);
Adornment.displayName = 'Adornment';
export default Adornment;
